import React from 'react'
import Enrollment from '../../../modules/ManageProspect/Enrollment'

const EnrollmentPage = () => {
  return <Enrollment />
}

export default EnrollmentPage
